import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import Confetti from 'react-confetti';

const PageContainer = styled.div`
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  padding: 40px;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 215, 0, 0.2);
  backdrop-filter: blur(3px);
  text-align: center;
`;

const Title = styled.h1`
  font-size: 42px;
  margin-bottom: 40px;
  text-align: center;
  color: var(--gold-color);
  text-shadow: 0 2px 10px rgba(255, 215, 0, 0.5);
`;

const TimerDisplay = styled.div`
  font-size: 52px;
  font-weight: bold;
  margin: 30px 0;
  color: var(--gold-color);
  text-shadow: 0 2px 15px rgba(255, 215, 0, 0.6);
  font-family: var(--mono-font);
  letter-spacing: 2px;
`;

const SalaryDisplay = styled.div`
  font-size: 42px;
  font-weight: bold;
  margin: 30px 0;
  color: var(--gold-color);
  text-shadow: 0 2px 15px rgba(255, 215, 0, 0.6);
`;

const FinishButton = styled.button`
  margin-top: 40px;
  font-size: 20px;
  padding: 15px 40px;
  background: rgba(212, 175, 55, 0.8);
  border: none;
  color: #000;
  font-weight: bold;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  font-family: var(--main-font);
  
  &:hover {
    background: rgba(255, 215, 0, 0.9);
    transform: translateY(-2px);
    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.3);
  }
  
  &:active {
    transform: translateY(1px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  }
`;

const ConfettiWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 100;
  pointer-events: none;
`;

const GoldCoinVideo = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 200;
  pointer-events: none;
  opacity: ${props => props.opacity};
  transition: opacity 1s ease-in-out;
  mix-blend-mode: screen;
`;

const VideoElement = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: opacity 2s ease;
  opacity: 0.7;
`;

const WorkingPage = () => {
  const navigate = useNavigate();
  const [time, setTime] = useState(0); // 时间，以毫秒为单位
  const [salary, setSalary] = useState(0); // 已赚工资
  const [showConfetti, setShowConfetti] = useState(false);
  const [showGoldCoin, setShowGoldCoin] = useState(false);
  const [goldCoinOpacity, setGoldCoinOpacity] = useState(0);
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });
  const lastConfettiTime = useRef(0);
  const salaryData = useRef(JSON.parse(localStorage.getItem('salaryData') || '{"monthlySalary":10000,"hoursPerDay":8,"workdaysPerMonth":22}'));
  const startTime = useRef(Date.now());
  
  // 计算每毫秒的工资
  const salaryPerMs = useRef(
    salaryData.current.monthlySalary / 
    (salaryData.current.workdaysPerMonth * salaryData.current.hoursPerDay * 60 * 60 * 1000)
  );

  // 播放金币视频的函数
  const playGoldCoinVideo = () => {
    console.log("工作页面：尝试播放金币视频");
    
    // 先显示视频容器
    setShowGoldCoin(true);
    setGoldCoinOpacity(0.3);
    
    // 给DOM时间渲染
    setTimeout(() => {
      const videoElement = document.querySelector('.gold-coin-video');
      console.log("工作页面：查找视频元素", videoElement);
      
      if (videoElement) {
        // 设置视频属性
        videoElement.muted = true;
        videoElement.currentTime = 0;
        videoElement.loop = false; // 确保视频不循环播放
        
        // 播放视频
        console.log("工作页面：开始播放金币视频");
        videoElement.play()
          .then(() => {
            console.log("工作页面：金币视频开始播放成功");
            // 淡入
            setGoldCoinOpacity(0.8); // 最大不透明度设为80%
            
            // 监听视频结束事件
            videoElement.onended = () => {
              console.log("工作页面：金币视频播放结束");
              handleGoldCoinEnd();
            };
            
            // 设置安全定时器，确保视频会在一定时间后消失
            // 视频时长约为4-5秒，设置6秒的定时器确保视频会结束
            setTimeout(() => {
              console.log("工作页面：金币视频播放超时，强制结束");
              handleGoldCoinEnd();
            }, 6000);
          })
          .catch(error => {
            console.error("工作页面：金币视频播放失败:", error);
          });
      } else {
        console.error("工作页面：找不到视频元素");
      }
    }, 500);
  };
  
  // 处理金币视频结束的函数
  const handleGoldCoinEnd = () => {
    // 淡出
    setGoldCoinOpacity(0);
    setTimeout(() => {
      setShowGoldCoin(false);
      console.log("工作页面：隐藏金币视频元素");
    }, 1000);
  };

  useEffect(() => {
    // 监听窗口大小变化
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };
    
    window.addEventListener('resize', handleResize);
    
    // 每 100 毫秒更新一次
    const timer = setInterval(() => {
      const currentTime = Date.now();
      const elapsedTime = currentTime - startTime.current;
      setTime(elapsedTime);
      
      // 计算已赚工资
      const earnedSalary = elapsedTime * salaryPerMs.current;
      setSalary(earnedSalary);
      
      // 检查是否需要显示彩带和金币视频
      if (earnedSalary - lastConfettiTime.current >= 10) {
        setShowConfetti(true);
        lastConfettiTime.current = Math.floor(earnedSalary / 10) * 10;
        
        // 播放金币视频
        playGoldCoinVideo();
        
        // 3秒后隐藏彩带
        setTimeout(() => {
          setShowConfetti(false);
        }, 3000);
      }
    }, 100);
    
    return () => {
      clearInterval(timer);
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  
  const handleFinish = () => {
    // 保存结果到 localStorage
    localStorage.setItem('workResult', JSON.stringify({
      duration: time,
      earnedSalary: salary
    }));
    
    // 导航到结果页面
    navigate('/result');
  };
  
  // 格式化时间显示
  const formatTime = (ms) => {
    const totalSeconds = Math.floor(ms / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    const milliseconds = Math.floor((ms % 1000) / 10);
    
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}.${milliseconds.toString().padStart(2, '0')}`;
  };

  return (
    <>
      {showConfetti && (
        <ConfettiWrapper>
          <Confetti
            width={windowSize.width}
            height={windowSize.height}
            recycle={false}
            numberOfPieces={1000}
            colors={['#FFD700', '#D4AF37', '#F5F5DC', '#FFFACD', '#FFDF00']}
            gravity={0.15}
          />
        </ConfettiWrapper>
      )}
      
      {showGoldCoin && (
        <GoldCoinVideo opacity={goldCoinOpacity}>
          <VideoElement 
            className="gold-coin-video"
            muted
            playsInline
            preload="auto"
            src="/mp4/bg-gold.mp4"
            type="video/mp4"
            onError={(e) => console.error("工作页面：视频加载错误:", e)}
            onLoadStart={() => console.log("工作页面：视频开始加载")}
            onLoadedData={() => console.log("工作页面：视频数据加载完成")}
          />
        </GoldCoinVideo>
      )}
      
      <PageContainer>
        <Title>正在上班中</Title>
        
        <TimerDisplay>
          {formatTime(time)}
        </TimerDisplay>
        
        <SalaryDisplay>
          已赚: ¥{salary.toFixed(2)}
        </SalaryDisplay>
        
        <FinishButton onClick={handleFinish}>下班</FinishButton>
      </PageContainer>
    </>
  );
};

export default WorkingPage; 